import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {textHandle} from 'presentation/utils/textHandle';
import {DataContentCard} from '../../../../components/DataContentCard';
import {StyledCard, StyledDataContent, StyledHeaderContainer, StyledTitle} from './styles';
import {DoctorVisitsCardType} from './types';

const {visitMade} = translations['pt-br'].privateFlow.myHospitalization.doctorVisits.card;

export const DoctorVisitsCard = ({doctor, dataTestId}: DoctorVisitsCardType) => (
	<StyledCard data-test-id={dataTestId}>
		<StyledHeaderContainer>
			<StyledTitle variant="h6">{textHandle(doctor.doctorName).capitalize()}</StyledTitle>
			<Typography variant="subtitle1">{doctor.crm}</Typography>
		</StyledHeaderContainer>
		<StyledDataContent>
			<DataContentCard
				iconName="query-builder-filled"
				title={visitMade}
				description={doctor.visitDate}
			/>
		</StyledDataContent>
	</StyledCard>
);
